<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 244.8 264.8" style="enable-background:new 0 0 244.8 264.8;" xml:space="preserve">
    <g>
      <defs>
        <rect id="t1_SVGID_1_" x="65.7" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="t1_SVGID_2_">
        <use xlink:href="#t1_SVGID_1_" style="overflow:visible;"/>
      </clipPath>
      <g class="s1t0">
        <g>
          <defs>
            <path id="t1_SVGID_3_" d="M74.7,0h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H74.7
              c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4S72.3,0,74.7,0z"/>
          </defs>
          <clipPath id="t1_SVGID_4_">
            <use xlink:href="#t1_SVGID_3_" style="overflow:visible;"/>
          </clipPath>
          <g class="s1t1">
            <path class="s1t2" d="M65.7,0h113.4v113.4H65.7V0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t1_SVGID_5_" x="65.7" y="151.4" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="t1_SVGID_6_">
        <use xlink:href="#t1_SVGID_5_" style="overflow:visible;"/>
      </clipPath>
      <g class="s1t3">
        <g>
          <defs>
            <path id="t1_SVGID_7_" d="M74.7,151.4h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6
              H74.7c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4C70,152.4,72.3,151.4,74.7,151.4z"/>
          </defs>
          <clipPath id="t1_SVGID_8_">
            <use xlink:href="#t1_SVGID_7_" style="overflow:visible;"/>
          </clipPath>
          <g class="s1t4">
            <path class="s1t2" d="M65.7,151.4h113.4v113.4H65.7V151.4z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t1_SVGID_9_" y="20" width="244.8" height="244.8"/>
      </defs>
      <clipPath id="t1_SVGID_10_">
        <use xlink:href="#t1_SVGID_9_" style="overflow:visible;"/>
      </clipPath>
      <g class="s1t5">
        <g>
          <defs>
            <path id="t1_SVGID_11_" d="M23,20h198.8c12.7,0,23,10.3,23,23v198.8c0,12.7-10.3,23-23,23H23c-12.7,0-23-10.3-23-23V43
              C0,30.3,10.3,20,23,20z"/>
          </defs>
          <clipPath id="t1_SVGID_12_">
            <use xlink:href="#t1_SVGID_11_" style="overflow:visible;"/>
          </clipPath>
          <g class="s1t6">
            <path class="s1t7" d="M0,20h244.8v244.8H0V20z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t1_SVGID_13_" x="29.3" y="49.3" width="186.3" height="186.3"/>
      </defs>
      <clipPath id="t1_SVGID_14_">
        <use xlink:href="#t1_SVGID_13_" style="overflow:visible;"/>
      </clipPath>
      <g class="s1t8">
        <g>
          <defs>
            <circle id="t1_SVGID_15_" cx="122.4" cy="142.4" r="93.1"/>
          </defs>
          <clipPath id="t1_SVGID_16_">
            <use xlink:href="#t1_SVGID_15_" style="overflow:visible;"/>
          </clipPath>
          <g class="s1t9">
            <path class="s1t2" d="M29.3,49.3h186.3v186.3H29.3V49.3z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 't1'
}
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
/*    fill: var(--principal);*/
/*    filter: brightness(0.9);*/
  }
</style>

<style scoped>
  .s1t0{clip-path:url(#t1_SVGID_2_);}
  .s1t1{clip-path:url(#t1_SVGID_4_);}
  .s1t2{fill:#2C6EDF;}
  .s1t3{clip-path:url(#t1_SVGID_6_);}
  .s1t4{clip-path:url(#t1_SVGID_8_);}
  .s1t5{clip-path:url(#t1_SVGID_10_);}
  .s1t6{clip-path:url(#t1_SVGID_12_);}
  .s1t7{fill:#85B0F9;}
  .s1t8{clip-path:url(#t1_SVGID_14_);}
  .s1t9{clip-path:url(#t1_SVGID_16_);}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/t1.vue